export default __webpack_public_path__ + "static/media/Dislike_Active.f09224f0.svg";